import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.21.11_@netlify+blobs@8.2.0_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+nod_6ov5qllacxytyqciuuaqdxie5q/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45global from "/opt/build/repo/src/middleware/route.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.21.11_@netlify+blobs@8.2.0_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+nod_6ov5qllacxytyqciuuaqdxie5q/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}